/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuCrossOwnerDocsSendCloseDataToDmvsPartialUpdateRequest = {} | null | undefined;
export type SvuCrossOwnerDocsSendCloseDataToDmvsPartialUpdateResponse = any;

export type SvuCrossOwnerDocsSendCloseDataToDmvsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/svu_cross_owner_docs/{id}/send_close_data_to_dmvs/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_send_close_data_to_dmvs_partial_update
 * tags:
 *   - svu_cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuCrossOwnerDocsSendCloseDataToDmvsPartialUpdateOperation = ({
  id,
  ...rest
}: SvuCrossOwnerDocsSendCloseDataToDmvsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_cross_owner_docs/${id}/send_close_data_to_dmvs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & {
      _templateUrl: '/dmx-server/svu_cross_owner_docs/{id}/send_close_data_to_dmvs/';
    };
  };

/**
 * PATCH /dmx-server/svu_cross_owner_docs/{id}/send_close_data_to_dmvs/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_send_close_data_to_dmvs_partial_update
 * tags:
 *   - svu_cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuCrossOwnerDocsSendCloseDataToDmvsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuCrossOwnerDocsSendCloseDataToDmvsPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuCrossOwnerDocsSendCloseDataToDmvsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
